import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=ed0b1dae&scoped=true"
import script from "./AppLoader.vue?vue&type=script&lang=ts"
export * from "./AppLoader.vue?vue&type=script&lang=ts"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=ed0b1dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0b1dae",
  null
  
)

export default component.exports